import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// TODO: Move all bottom sheets state from Ticket.vue to here
export const useJobBottomSheetStatesStore = defineStore(
  'jobBottomSheetStates',
  () => {
    const jobBottomSheetStates = ref({
      isTagBottomSheetVisible: false,
      isNewGuestUserBottomSheetVisible: false,
      isSignatureBottomSheetVisible: false,
      isLineItemBottomSheetVisible: false,
      isBatchBottomSheetVisible: false,
      isProjectBottomSheetVisible: false,
      isSendingEmailForApprovalBottomSheetVisible: false,
      isRejectingApprovalBottomSheetVisible: false,
      isEditingPlannedActualTimesBottomSheetVisible: false,
      isEditingJobDetailsBottomSheetVisible: false,
      isEditingLocationsAndInventoryBottomSheetVisible: false,
      isCreatingLocationOnTheFlyBottomSheetVisible: false,
      isAddReceiptBottomSheetVisible: false,
    })

    const isBottomSheetVisible = computed(
      () =>
        jobBottomSheetStates.value.isTagBottomSheetVisible ||
        jobBottomSheetStates.value.isNewGuestUserBottomSheetVisible ||
        jobBottomSheetStates.value.isSignatureBottomSheetVisible ||
        jobBottomSheetStates.value.isLineItemBottomSheetVisible ||
        jobBottomSheetStates.value.isBatchBottomSheetVisible ||
        jobBottomSheetStates.value.isProjectBottomSheetVisible ||
        jobBottomSheetStates.value.isCreatingLocationOnTheFlyBottomSheetVisible
    )

    const isCompletedJobBottomSheetVisible = computed(
      () =>
        jobBottomSheetStates.value.isEditingJobDetailsBottomSheetVisible ||
        jobBottomSheetStates.value
          .isEditingLocationsAndInventoryBottomSheetVisible ||
        jobBottomSheetStates.value.isTagBottomSheetVisible ||
        jobBottomSheetStates.value
          .isEditingPlannedActualTimesBottomSheetVisible ||
        jobBottomSheetStates.value.isLineItemBottomSheetVisible ||
        jobBottomSheetStates.value.isBatchBottomSheetVisible ||
        jobBottomSheetStates.value.isRejectingApprovalBottomSheetVisible ||
        jobBottomSheetStates.value
          .isSendingEmailForApprovalBottomSheetVisible ||
        jobBottomSheetStates.value.isSignatureBottomSheetVisible ||
        jobBottomSheetStates.value.isAddReceiptBottomSheetVisible
    )

    const isBottomSheetFullHeight = computed(
      () =>
        !jobBottomSheetStates.value.isBatchBottomSheetVisible &&
        !jobBottomSheetStates.value.isNewGuestUserBottomSheetVisible &&
        !jobBottomSheetStates.value.isTagBottomSheetVisible
    )

    const isCompletedJobBottomSheetFullHeight = computed(
      () =>
        jobBottomSheetStates.value.isLineItemBottomSheetVisible ||
        jobBottomSheetStates.value.isRejectingApprovalBottomSheetVisible ||
        jobBottomSheetStates.value
          .isSendingEmailForApprovalBottomSheetVisible ||
        jobBottomSheetStates.value
          .isEditingLocationsAndInventoryBottomSheetVisible ||
        jobBottomSheetStates.value.isAddReceiptBottomSheetVisible
    )

    const setJobBottomSheetStates = (newState: {
      isTagBottomSheetVisible?: boolean
      isNewGuestUserBottomSheetVisible?: boolean
      isSignatureBottomSheetVisible?: boolean
      isLineItemBottomSheetVisible?: boolean
      isBatchBottomSheetVisible?: boolean
      isProjectBottomSheetVisible?: boolean
      isSendingEmailForApprovalBottomSheetVisible?: boolean
      isRejectingApprovalBottomSheetVisible?: boolean
      isEditingPlannedActualTimesBottomSheetVisible?: boolean
      isEditingJobDetailsBottomSheetVisible?: boolean
      isEditingLocationsAndInventoryBottomSheetVisible?: boolean
      isCreatingLocationOnTheFlyBottomSheetVisible?: boolean
      isAddReceiptBottomSheetVisible?: boolean
    }) => {
      jobBottomSheetStates.value = {
        ...jobBottomSheetStates.value,
        ...newState,
      }
    }

    const clearJobBottomSheetStates = () => {
      jobBottomSheetStates.value = {
        isTagBottomSheetVisible: false,
        isNewGuestUserBottomSheetVisible: false,
        isSignatureBottomSheetVisible: false,
        isLineItemBottomSheetVisible: false,
        isBatchBottomSheetVisible: false,
        isProjectBottomSheetVisible: false,
        isSendingEmailForApprovalBottomSheetVisible: false,
        isRejectingApprovalBottomSheetVisible: false,
        isEditingPlannedActualTimesBottomSheetVisible: false,
        isEditingJobDetailsBottomSheetVisible: false,
        isEditingLocationsAndInventoryBottomSheetVisible: false,
        isCreatingLocationOnTheFlyBottomSheetVisible: false,
        isAddReceiptBottomSheetVisible: false,
      }
    }

    return {
      jobBottomSheetStates,
      isBottomSheetVisible,
      isCompletedJobBottomSheetVisible,
      isBottomSheetFullHeight,
      isCompletedJobBottomSheetFullHeight,
      setJobBottomSheetStates,
      clearJobBottomSheetStates,
    }
  }
)
